const l = {
  // Compatibility precomposed letters
  ß: "ss",
  // U+00DF LATIN SMALL LETTER SHARP S
  æ: "ae",
  // U+00E6 LATIN SMALL LETTER AE (ash)
  œ: "oe",
  // U+0153 LATIN SMALL LETTER OE (ethel)
  đ: "d",
  // U+0111 LATIN SMALL LETTER D WITH STROKE
  ħ: "h",
  // U+0127 LATIN SMALL LETTER H WITH STROKE
  ı: "i",
  // U+0131 LATIN SMALL LETTER DOTLESS I
  ĸ: "k",
  // U+0138 LATIN SMALL LETTER KRA
  ŀ: "l",
  // U+0140 LATIN SMALL LETTER L WITH MIDDLE DOT
  ł: "l",
  // U+0142 LATIN SMALL LETTER L WITH STROKE
  ø: "o",
  // U+00F8 LATIN SMALL LETTER O WITH STROKE
  þ: "th",
  // U+00FE LATIN SMALL LETTER THORN
  ſ: "s",
  // U+017F LATIN SMALL LETTER LONG S
  // Alphabetic Presentation Forms – compatibility ligatures (U+FB00–U+FB06)
  ﬁ: "fi",
  // FI LATIN SMALL LIGATURE FI
  ﬂ: "fl",
  // FL LATIN SMALL LIGATURE FL
  ﬃ: "ffi",
  // FFI LATIN SMALL LIGATURE FFI
  ﬄ: "ffl",
  // FFL LATIN SMALL LIGATURE FFL
  ﬅ: "st",
  // ST LATIN SMALL LIGATURE ST
  ﬆ: "st"
  // ST LATIN SMALL LIGATURE ST
}, a = new RegExp(Object.keys(l).join("|"), "g"), s = /[\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\uFE20-\uFE2F]/g;
function i(e, n, t) {
  if (!e)
    return "";
  const { locale: o } = t.resolvedOptions();
  return n !== "base" ? e.normalize("NFC").toLocaleLowerCase(o) : e.normalize("NFD").toLocaleLowerCase(o).replace(s, "").replace(a, (r) => l[r]);
}
export {
  i as normalizeForCollation
};
